module.exports = __webpack_public_path__ + "img/limited-time-offer-banner.b5133836.svg";